/* eslint-disable max-lines-per-function */
import React from "react";

export default function Disclaimer() {
    return (
        <div
            style={{
                marginBottom: 50,
                padding: "0px 50px",
            }}
        >
            <p
                data-renderer-start-pos={500}
                style={{
                    margin: "0.75rem 0px 0px",
                    padding: "0px",
                    fontSize: "14px",
                    lineHeight: "1.714",
                    fontWeight: 400,
                    letterSpacing: "-0.005em",
                    color: "rgb(23, 43, 77)",
                    fontFamily:
                        '-apple-system, "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    orphans: 2,
                    textAlign: "start",
                    textIndent: "0px",
                    textTransform: "none",
                    whiteSpace: "pre-wrap",
                    widows: 2,
                    wordSpacing: "0px",
                    WebkitTextStrokeWidth: "0px",
                    textDecorationThickness: "initial",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial",
                }}
            >
                <strong data-renderer-mark="true">
                    Warnung zum Datenschutz und IT-Sicherheit
                </strong>
            </p>
            <ul
                className="ak-ul"
                data-indent-level={1}
                style={{
                    margin: "12px 0px 0px",
                    padding: "0px 0px 0px 24px",
                    boxSizing: "border-box",
                    listStyleType: "disc",
                    display: "flow-root",
                    color: "rgb(23, 43, 77)",
                    fontFamily:
                        '-apple-system, "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "start",
                    textIndent: "0px",
                    textTransform: "none",
                    whiteSpace: "pre-wrap",
                    widows: 2,
                    wordSpacing: "0px",
                    WebkitTextStrokeWidth: "0px",
                    textDecorationThickness: "initial",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial",
                }}
            >
                <li>
                    <p
                        data-renderer-start-pos={545}
                        style={{
                            margin: "0px",
                            padding: "0px",
                            fontSize: "1em",
                            lineHeight: "1.714",
                            fontWeight: "normal",
                            letterSpacing: "-0.005em",
                        }}
                    >
                        Bitte geben Sie möglichst keine Rückmeldungen via
                        E-Mail, die für die Terminbuchung nicht unbedingt
                        erforderlich sind (z.B. Datum des nächsten Termins,
                        Versicherungsnummer, Anzahl bisheriger Termine).
                    </p>
                </li>
                <li style={{ marginTop: "4px" }}>
                    <p
                        data-renderer-start-pos={749}
                        style={{
                            margin: "0px",
                            padding: "0px",
                            fontSize: "1em",
                            lineHeight: "1.714",
                            fontWeight: "normal",
                            letterSpacing: "-0.005em",
                        }}
                    >
                        Terminbestätigungen werden automatisch vom System
                        versendet. Diese müssen und sollten aus
                        Datenschutzgründen nicht manuell versendet werden.
                    </p>
                </li>
                <li style={{ marginTop: "4px" }}>
                    <p
                        data-renderer-start-pos={893}
                        style={{
                            margin: "0px",
                            padding: "0px",
                            fontSize: "1em",
                            lineHeight: "1.714",
                            fontWeight: "normal",
                            letterSpacing: "-0.005em",
                        }}
                    >
                        <b>
                            Achten Sie auf Warnhinweise Ihres E-Mail-Programms
                        </b>{" "}
                        und geben Sie keine Nutzerdaten oder vertrauliche
                        Informationen an verdächtig wirkende E-Mails heraus.
                        Buchen Sie auch keine Termine für Versender solcher
                        E-Mails!
                    </p>
                </li>
                <li style={{ marginTop: "4px" }}>
                    <p
                        data-renderer-start-pos={1111}
                        style={{
                            margin: "0px",
                            padding: "0px",
                            fontSize: "1em",
                            lineHeight: "1.714",
                            fontWeight: "normal",
                            letterSpacing: "-0.005em",
                        }}
                    >
                        <b>
                            Termine, welche via Telefon angefragt werden, dürfen
                            nie über die Mailadresse, sondern nur über den
                            5-stelligen Buchungscode, welcher in der App
                            angezeigt wird, gebucht werden.
                        </b>
                    </p>
                </li>
                <li style={{ marginTop: "4px" }}>
                    <p
                        data-renderer-start-pos={1291}
                        style={{
                            margin: "0px",
                            padding: "0px",
                            fontSize: "1em",
                            lineHeight: "1.714",
                            fontWeight: "normal",
                            letterSpacing: "-0.005em",
                        }}
                    >
                        Termine dürfen nur für NutzerInnen gebucht werden, deren
                        Mailadresse im Mamly-System und deren
                        Absendermailadresse exakt übereinstimmen. Das
                        untenstehende Eingabefeld liefert ausschließlich 1 zu 1
                        übereinstimmende Ergebnisse.
                    </p>
                </li>
            </ul>
        </div>
    );
}
